import React from 'react';
import { Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faClock } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useTheme } from '../../../context/ThemeContext';

const getGreetingTime = (d: Date = new Date()): string => {
  const split_afternoon = 12;
  const split_evening = 17;
  const currentHour = d.getHours();

  if (currentHour >= split_afternoon && currentHour <= split_evening) {
    return 'afternoon';
  } else if (currentHour >= split_evening) {
    return 'evening';
  }
  return 'morning';
};

interface GreetingSectionProps {
  lastUpdated?: string;
}

const GreetingSection: React.FC<GreetingSectionProps> = ({ lastUpdated = 'Never' }) => {
  const { theme: themeMode } = useTheme();
  const isDarkMode = themeMode === 'dark';
  const { merchantData } = useSelector((state: RootState) => state.merchantDashboard);

  const managerName = merchantData?.name || 'Manager';
  const timeOfDay = getGreetingTime();
  const greeting = `Good ${timeOfDay}, ${managerName}`;

  const colors = {
    cardBg: isDarkMode ? '#1a202c' : '#ffffff',
    cardBorder: isDarkMode ? '#4a5568' : '#e2e8f0',
    textPrimary: isDarkMode ? '#e2e8f0' : '#1a202c',
    textSecondary: isDarkMode ? '#a0aec0' : '#718096',
  };

  return (
    <div
      style={{
        background: colors.cardBg,
        border: `1px solid ${colors.cardBorder}`,
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '24px',
      }}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Space size="middle" align="center">
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              background: '#2D6CCA',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontSize: '24px',
              flexShrink: 0,
            }}
          >
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div>
            <h2
              style={{
                fontSize: '24px',
                fontWeight: 700,
                margin: 0,
                color: colors.textPrimary,
              }}
            >
              {greeting}
            </h2>
            <p
              style={{
                fontSize: '14px',
                color: colors.textSecondary,
                margin: '4px 0 0 0',
              }}
            >
              Welcome back to your dashboard
            </p>
          </div>
        </Space>

        <Space size="large">
          <Space size="small">
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '16px',
                height: '16px',
                color: colors.textSecondary,
              }}
            >
              <FontAwesomeIcon icon={faClock} />
            </span>
            <span style={{ fontSize: '13px', color: colors.textSecondary }}>
              Last updated {lastUpdated}
            </span>
          </Space>
        </Space>
      </Space>
    </div>
  );
};

export default GreetingSection;
